export const goFromMenus = function(id, hash, $router) {
    const item = (hash[id] || {})
    const { path, route_type} = item
    switch (route_type) {
      case 'powerbi':
        $router.push({path, query: { rt: new Date().getTime() }});
        break;
      case 'iframe':
        $router.push({path, query: { rt: new Date().getTime() }});
        break;
      case 'url-open':
        window.open(path);
        break;
      default:
        $router.push({path, query: { rt: new Date().getTime() }});
        break;
    }
}
